// eslint-disable-next-line
import { getTenantConfig, Tenant } from '../tenant'

export const Format = {
  camelCase(val: string | null | undefined): string {
    // hello world > Hello world
    return val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : ''
  },

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  },

  capitalizeWords(string: string) {
    return string
      .split(' ')
      .map((v) => Format.capitalizeFirstLetter(v))
      .join(' ')
  },

  enumeration: {
    get(value: string | null | undefined): string {
      // MY_CONSTANT > My constant
      if (!value) {
        return ''
      }
      return Format.camelCase(value.replace(/_/g, ' '))
    },
    set(value: string): string {
      // My Constant > MY_CONSTANT
      return value ? value.replace(/ /g, '_').toUpperCase() : ''
    },
  },
  money: (value: number, tenant?: string | Tenant) => {
    // Get tenant configuration from API (via cache)
    // tenant parameter allows overriding tenant detection
    // Examples: Tenant.AU, 'au', 'uk', '/au/checkout', or undefined (current location)
    const tenantConfig = getTenantConfig(tenant)

    if (value) {
      return (value / 100)?.toLocaleString(tenantConfig.locale, {
        currency: tenantConfig.currency,
        style: 'currency',
      })
    }
    return (0).toLocaleString(tenantConfig.locale, {
      currency: tenantConfig.currency,
      style: 'currency',
    })
  },
  moneyShort: (value: number, tenant?: string | Tenant) => {
    const formatted = Format.money(value, tenant)
    // Remove decimal places if they're .00 (handles both . and , as decimal separators)
    return formatted.replace(/[.,]00$/, '')
  },
}
